import { Box, Link, Typography } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { GetSuggestedMeetingGuestsQuery } from "./GetSuggestedMeetingGuests.generated";

export type SuggestedGuest =
  GetSuggestedMeetingGuestsQuery["suggestedMeetingGuests"][number];

type Props = {
  suggestions: SuggestedGuest[];
  onSelect: (guest: SuggestedGuest) => void;
};

export default function SuggestedGuests({ suggestions, onSelect }: Props) {
  const { t } = useTranslation();

  if (suggestions.length === 0) return null;

  return (
    <Box sx={{ alignContent: "center" }}>
      <Typography
        variant="body2"
        component="span"
        sx={{ color: "text.secondary" }}
      >
        {t("Previous: ")}
      </Typography>
      {suggestions.map((suggestion, index) => (
        <Fragment
          key={
            suggestion.registeredGuest?.id ?? suggestion.unregisteredGuestName
          }
        >
          {index > 0 && ", "}
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={() => onSelect(suggestion)}
          >
            {suggestion.registeredGuest?.fullName ??
              suggestion.unregisteredGuestName}
          </Link>
        </Fragment>
      ))}
    </Box>
  );
}
